import { useTranslation } from "react-i18next";

export default function ArticleGrid() {
  const { t } = useTranslation("blog");
  const items = t("articles.items", { returnObjects: true }) as Array<{
    title: string;
    excerpt: string;
    href: string;
    status: string;
    image?: string;
  }>;
  const readMore = t("articles.readMore");
  const soonLabel = t("articles.soon");

  return (
    <section className="py-10 md:py-16 bg-white">
      <div className="max-w-[1024px] mx-auto px-4 md:px-6">
        <h2 className="font-geist font-bold text-xl md:text-2xl text-brand-text mb-8 md:mb-12">
          {t("articles.h2")}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {items.map((item, idx) => {
            const isActive = item.status === "active";
            return (
              <a
                key={idx}
                href={item.href}
                className={`group block rounded-2xl border overflow-hidden transition-all duration-300 hover:shadow-lg ${
                  isActive
                    ? "border-brand-border bg-white hover:border-brand-yellow"
                    : "border-brand-border/40 bg-brand-cream/40"
                }`}
              >
                <div
                  className={`relative h-48 md:h-56 w-full overflow-hidden ${
                    isActive ? "" : "bg-neutral-100"
                  }`}
                >
                  {isActive && item.image ? (
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                      loading="lazy"
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center">
                      <div className="w-12 h-12 md:w-16 md:h-16 rounded-full bg-neutral-200 flex items-center justify-center">
                        <i className="ri-article-line text-2xl md:text-3xl text-neutral-400"></i>
                      </div>
                    </div>
                  )}
                  {!isActive && (
                    <span className="absolute top-3 right-3 font-geist-mono text-[10px] md:text-xs font-bold bg-neutral-200 text-neutral-500 px-2 py-1 rounded-full uppercase tracking-wider">
                      {soonLabel}
                    </span>
                  )}
                </div>
                <div className="p-4 md:p-5">
                  <h3
                    className={`font-geist font-semibold text-base md:text-lg mb-2 leading-snug ${
                      isActive
                        ? "text-brand-text group-hover:text-brand-text"
                        : "text-brand-text/50"
                    }`}
                  >
                    {item.title}
                  </h3>
                  <p
                    className={`font-geist text-sm leading-relaxed mb-3 md:mb-4 ${
                      isActive ? "text-brand-text/60" : "text-brand-text/30"
                    }`}
                  >
                    {item.excerpt}
                  </p>
                  {isActive ? (
                    <span className="inline-flex items-center gap-1.5 font-geist text-sm font-medium text-brand-text group-hover:text-brand-yellow transition-colors">
                      {readMore}
                      <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center text-sm transition-transform group-hover:translate-x-1"></i>
                    </span>
                  ) : (
                    <span className="inline-flex items-center gap-1.5 font-geist text-sm font-medium text-brand-text/30">
                      {soonLabel}
                      <i className="ri-time-line w-4 h-4 flex items-center justify-center text-sm"></i>
                    </span>
                  )}
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}